<template>
  <SeoPage page-key="gestionaliOdooLugano" />
</template>

<script setup>
import SeoPage from '../components/SeoPage.vue'

defineOptions({
  name: 'GestionaliOdooLuganoPage'
})
</script>

